import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { SealCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { H3 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getBidderPhoneNumber } from '@/redux/modules/account/user/user.selectors';
import { openPhoneVerificationModal } from '@/redux/modules/modal';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    className?: string;
};

export const ApprovePhoneNumber = ({ className }: Props) => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    const mobileNumber = useAppSelector(getBidderPhoneNumber);

    const onClick = () => {
        dispatch(openPhoneVerificationModal());
    };

    return (
        <div
            className={cn(
                'flex w-[384px] flex-col items-center border border-border-secondary bg-background-tertiary p-lg smMax:w-full',
                className
            )}
        >
            <SealCheck
                color="success"
                size="lg"
                style="duotone"
            />

            <H3 className="mb-lg mt-xs text-center">{formatMessage(['accountSettingsPage', 'getApprovedFaster'])}</H3>
            <Button
                className="w-full"
                onClick={onClick}
            >
                {formatMessage(['accountSettingsPage', mobileNumber ? 'verifyMobileNumber' : 'addMobileNumber'])}
            </Button>
        </div>
    );
};
